export interface TipoEdital {
    IdTipoEdital: number;
    DsTipoEdital: string;
}

export const TIPO_EDITAL_CODIGO: Record<number, 'CON' | 'PSS' | 'PSP'> = {
    1: 'CON',
    2: 'PSP',
    3: 'PSS',
};